import request from "@/utils/request";

/**
 * 获取APP下载地址
 *
 * @description 获取APP下载地址
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getUrlForDownload(playload) {
  return request({
    url: "/api/v2/app/getUrlForDownload",
    method: "POST",
    data: playload
  });
}

export async function getLanguageConfig(playload) {
  return request({
    url: "/api/v2/app/getLanguageConfig",
    method: "POST",
    data: playload,
    noEncrypt: false
  });
}
